import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';

const styles = {
  categoryWrapper: {
    paddingTop: '3.8rem',
    borderTop: `0.1rem solid ${colors.neutral[500]}`,
    marginBottom: '3.8rem',
  },
  infoWrapper: {
    border: `0.1rem solid ${colors.neutral[500]}`,
    borderRadius: '1rem',
    padding: '1.8rem',
  },
  infoBlock: {
    '&:not(:last-child)': {
      marginBottom: '2.5rem',
    },
  },
  title: {
    fontSize: '2rem',
    lineHeight: '2.8rem',
    textAlign: 'center',
    margin: 0,
    paddingBottom: '1.2rem',
    marginBottom: '2.8rem',
    borderBottom: `0.1rem solid ${colors.neutral[500]}`,
  },
  infoKey: {
    textTransform: 'uppercase',
    fontSize: '1.4rem',
    fontWeight: 700,
    margin: 0,
    marginBottom: '1rem',
    letterSpacing: '0.05rem',
  },
  infoValue: {
    margin: 0,
    fontSize: '1.8rem',
    color: colors.neutral[700],
    wordBreak: 'break-word',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
